import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { getIn } from 'formik';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector, useDispatch } from 'react-redux';
import { actions as companyActions } from 'redux/companies';
import { actions as locationActions } from 'redux/locations';
import { actions as farmActions } from 'redux/farms';

import _ from 'lodash';
import api from 'lib/api';
import utils, { getDecryptedUrl } from 'lib/utils';

export default function FarmLocationSelect(props) {
  const {
    field,
    form: { touched, values, errors },
    label,
    children,
    select,
    variant,
    initialDisplayText,
    setFieldValue,
    bill_to_address_id,
    entity_id,
    setDealChargesParams,
    setPrepaidBalance,
    setIsNotSubscribedLoacation,
    setIsPrepaidPlanLocation,
    setPackagingParams,
    isEditBidPopup,
    getStockDetails,
    getTransportationCharges,
    formik,
    setFromLocationId,
    setToLocationId,
    setIsLUTLocation,
    setIsSezLocation,
    ...rest
  } = props;

  let loading = false;
  let options = [];
  const loc = getDecryptedUrl(window.location.href);
  const [value, setValue] = React.useState(initialDisplayText);

  const dispatch = useDispatch();
  const farms = useSelector((state) => state.farms);
  const farmData = _.get(farms, `entities`) || {};
  const user = useSelector((state) => state.user);
  const acl = utils.getACL(user);

  _.each(farmData, (item, id) => {
    options.push({
      label: _.get(item, 'address_text') || '',

      value: {
        id: parseInt(_.get(item, 'id') || 0),
        ...item,
      },
    });
  });

  if (!options.length) {
    loading = true;
  }

  useEffect(() => {
    if (loading) {
      dispatch(farmActions.fetchList());
    }
  }, [loading]);

  useEffect(() => {
    if (!loading) {
      let initialAddressId = _.get(props, `form.initialValues.${field.name}`) || 0;

      const initialSelected = options.filter((o) => initialAddressId === o.value?.id);
      setValue(initialSelected);
    }
  }, [loading]);

  useEffect(() => {
    getStockDetails && formik && getStockDetails(formik)
    getTransportationCharges && formik && getTransportationCharges(formik)
  }, [loading, values]);


  const getSubscriptionValidation = (isSubscribed, subscriptionPlanId) => {
    if (setIsNotSubscribedLoacation && setIsPrepaidPlanLocation) {
      if (isSubscribed) {
        setIsNotSubscribedLoacation(false);
        setIsPrepaidPlanLocation(false);
        if (subscriptionPlanId === 1 || subscriptionPlanId === 2 || subscriptionPlanId === 3) {
          setIsPrepaidPlanLocation(true);
        }
      } else {
        if (acl.isCompany) {
          setIsNotSubscribedLoacation(true);
          setIsPrepaidPlanLocation(false);
        } else {
          setIsNotSubscribedLoacation(false);
          setIsPrepaidPlanLocation(false);
        }
      }
    }
  };

  useEffect(() => {
    if (options.length === 1 && field.name != 'bill_to_address_id') {
      setValue(options[0]);
      const addressId = _.get(options[0], 'value.company_address_id') || 0;
      setFieldValue(field.name, addressId);
      props.cb(options[0]);
    } else if (options.length && field.name != 'bill_to_address_id') {
      let selectedAddress;
      let addressId = values[field.name];
      if ((loc.includes('edit') || loc.includes('isEdit') || isEditBidPopup) && values[field.name]) {
        if (field.name === 'to_address_id') {
          setFieldValue('bill_to_address_id', addressId);
        }
        selectedAddress = options.filter((item) => item?.value?.id === addressId);
        if (!addressId) {
          selectedAddress = options.filter((item) => item?.value?.is_registered === true);
        }
      } else if (
        loc.includes('create') ||
        loc.includes(`overview`) ||
        loc.includes(`details`) ||
        loc.includes(`bids`) ||
        loc.includes(`deals`) ||
        loc.includes(`balance-position`)
      ) {
        selectedAddress = options.filter((item) => item?.value?.is_registered === true);
      }
      if(selectedAddress?.length) {
        addressId = addressId || _.get(selectedAddress?.[0], 'value.company_address_id') || 0;
        setFieldValue(field.name, addressId);
        let isLUTLocation = _.get(selectedAddress?.[0], 'value.is_lut_location');
        let isSezLocation = _.get(selectedAddress?.[0], 'value.is_sez_location');
        setIsLUTLocation && setIsLUTLocation(isLUTLocation);
        setIsSezLocation && setIsSezLocation(isSezLocation);
        setValue(selectedAddress?.[0]);
        props.cb(selectedAddress?.[0]);
      }
    }
  }, [loading, entity_id]);

  // useEffect(() => {
  //   if (options.length === 1) {
  //     setValue(options[0]);
  //     const addressId = _.get(options[0], 'value.id') || 0;
  //     setFieldValue(field.name, addressId);
  //     props.cb(options[0]);
  //   } else if (options.length) {
  //     if (loc.includes('edit') || loc.includes('isEdit')  || isEditBidPopup) {
  //       // const addressId = values.address_id;
  //       // const billToAddressId = values.bill_to_address_id;
  //       const addressId = values[field.name];
  //       const billToAddressId = values[field.name];
  //       if(field.name === 'to_address_id') {
  //         setFieldValue('bill_to_address_id', billToAddressId);
  //       }
  //       if ((field.name === 'address_id' || field.name === 'from_address_id') && addressId) {
  //         const selectedAddress = options.filter((item) => item?.value?.id === addressId);
  //         // let isSubscribed = _.get(selectedAddress[0], 'value.is_subscribed') || false;
  //         let isSubscribed = _.get(user, 'profile.is_subscribed') || false;
  //         let subscriptionPlanId = _.get(selectedAddress[0], 'value.subscription_plan_id') || 0;
  //         setValue(selectedAddress[0]);
  //         setFieldValue(field.name, addressId);
  //         setFromLocationId && setFromLocationId(addressId)
  //         setFieldValue('is_subscribed', isSubscribed);
  //         // getSubscriptionValidation(isSubscribed, subscriptionPlanId);
  //         // setDealChargesParams && setDealChargesParams({
  //         //   plan_id: selectedAddress[0]?.value?.subscription_plan_id,
  //         //   buyer_seller_id: selectedAddress[0]?.value?.entity_id,
  //         //   company_address_id: selectedAddress[0]?.value?.company_address_id,
  //         //   commodity_id: values?.commodity_id,
  //         //   commodity_form_id: values?.commodity_form_id,
  //         // });
  //         setPackagingParams &&
  //           setPackagingParams({
  //             location_id: addressId,
  //             commodity_form_id: values?.commodity_form_id,
  //             packaging_id: values?.packaging_id,
  //           });
  //         // setPrepaidBalance && setPrepaidBalance(_.get(selectedAddress[0], 'value.prepaid_balance') || 0);
  //       }
  //       if ((field.name === 'bill_to_address_id' || field.name === 'address_id' || field.name === 'to_address_id') && billToAddressId) {
  //         const selectedAddress = options.filter((item) => item?.value?.id === billToAddressId);
  //         // let isSubscribed = _.get(selectedAddress[0], 'value.is_subscribed') || false;
  //         let isSubscribed = _.get(user, 'profile.is_subscribed') || false;
  //         let subscriptionPlanId = _.get(selectedAddress[0], 'value.subscription_plan_id') || 0;
  //         setValue(selectedAddress[0]);
  //         setFieldValue(field.name, billToAddressId);
  //         setToLocationId && setToLocationId(billToAddressId)
  //         // getSubscriptionValidation(isSubscribed, subscriptionPlanId);
  //         // setDealChargesParams && setDealChargesParams({
  //         //   plan_id: selectedAddress[0]?.value?.subscription_plan_id,
  //         //   buyer_seller_id: selectedAddress[0]?.value?.entity_id,
  //         //   company_address_id: selectedAddress[0]?.value?.company_address_id,
  //         //   commodity_id: values?.commodity_id,
  //         //   commodity_form_id: values?.commodity_form_id,
  //         // });
  //         setPackagingParams &&
  //           setPackagingParams({
  //             location_id: addressId,
  //             commodity_form_id: values?.commodity_form_id,
  //             packaging_id: values?.packaging_id,
  //           });
  //         // setPrepaidBalance && setPrepaidBalance(_.get(selectedAddress[0], 'value.prepaid_balance') || 0);
  //       }
  //       if (!addressId || !billToAddressId) {
  //         const registeredAddresses = values?.address_id ? options.filter((item) => item?.value?.id === values?.address_id) : options.filter((item) => item?.value?.is_registered === true);
  //         // let isSubscribed = _.get(registeredAddresses[0], 'value.is_subscribed') || false;
  //         let isSubscribed = _.get(user, 'profile.is_subscribed') || false;
  //         let subscriptionPlanId = _.get(registeredAddresses[0], 'value.subscription_plan_id') || 0;
  //         setValue(registeredAddresses[0]);
  //         const addressId = _.get(registeredAddresses[0], 'value.id') || 0;
  //         setFieldValue(field.name, addressId);
  //         setFieldValue('is_subscribed', isSubscribed);
  //         // getSubscriptionValidation(isSubscribed, subscriptionPlanId);
  //         // setDealChargesParams && setDealChargesParams({
  //         //   plan_id: registeredAddresses[0]?.value?.subscription_plan_id,
  //         //   buyer_seller_id: registeredAddresses[0]?.value?.entity_id,
  //         //   company_address_id: registeredAddresses[0]?.value?.company_address_id,
  //         //   commodity_id: values?.commodity_id,
  //         //   commodity_form_id: values?.commodity_form_id,
  //         // });
  //         // setPrepaidBalance && setPrepaidBalance(_.get(registeredAddresses[0], 'value.prepaid_balance') || 0);
  //       }
  //     } else if (
  //       loc.includes('create') ||
  //       loc.includes(`overview`) ||
  //       loc.includes(`details`) ||
  //       loc.includes(`bids`) ||
  //       loc.includes(`deals`) ||
  //       loc.includes(`balance-position`)
  //     ) {
  //       let registeredAddresses = options.filter((item) => item?.value?.is_registered === true);
  //       registeredAddresses = registeredAddresses.length === 0 ? options : registeredAddresses;
  //       // let isSubscribed = _.get(registeredAddresses[0], 'value.is_subscribed') || false;
  //       let isSubscribed = _.get(user, 'profile.is_subscribed') || false;
  //       let subscriptionPlanId = _.get(registeredAddresses[0], 'value.subscription_plan_id') || 0;
  //       setValue(registeredAddresses[0]);
  //       const addressId = _.get(registeredAddresses[0], 'value.id') || 0;
  //       setFieldValue(field.name, addressId);
  //       setFieldValue('is_subscribed', isSubscribed);
  //       // getSubscriptionValidation(isSubscribed, subscriptionPlanId);
  //       // setDealChargesParams && setDealChargesParams({
  //       //   plan_id: registeredAddresses[0]?.value?.subscription_plan_id,
  //       //   buyer_seller_id: registeredAddresses[0]?.value?.entity_id,
  //       //   company_address_id: registeredAddresses[0]?.value?.company_address_id,
  //       //   commodity_id: values?.commodity_id,
  //       //   commodity_form_id: values?.commodity_form_id,
  //       // });
  //       // setPrepaidBalance && setPrepaidBalance(_.get(registeredAddresses[0], 'value.prepaid_balance') || 0);
  //       setPackagingParams &&
  //         setPackagingParams({
  //           location_id: addressId,
  //           commodity_form_id: values?.commodity_form_id,
  //           packaging_id: values?.packaging_id,
  //         });
  //     }
  //   }
  // }, [loading, entity_id]);

  const hasError = !!(getIn(touched, field.name) && getIn(errors, field.name));
  const errText = hasError ? getIn(errors, field.name) : '';

  return (
    <div className={`mui-single-select bfc-ref-data-select-wrapper ${hasError ? 'has-error' : ''}`}>
      <Autocomplete
        id={`aoi-${Date.now()}`}
        size="small"
        disableClearable
        fullWidth
        loading={loading}
        disabled={loading}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          } else if (Array.isArray(option)) {
            return _.get(option, `[0].label`) || '';
          } else {
            return option.label || '';
          }
        }}
        options={options}
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
          if (props.cb) {
            props.cb(newValue);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            {...field}
            fullWidth
            variant={variant || 'outlined'}
            label={label}
            children={children}
            select={select}
            error={hasError}
            helperText={errText}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </div>
  );
}
